import React from "react";

import { AuditRoleStatusBadge } from "../../../audit_planner/parts/audit_role_status/audit_role_status_badge";
import css from "./approval_status_badge.module.scss";

const ApprovalStatusBadge = ({ status }: { status: string }) => (
  <AuditRoleStatusBadge className={css.badge} status={status} />
);

export default ApprovalStatusBadge;
